/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Page_SubtitleInputs */

const vi_shop_home_page_subtitle = /** @type {(inputs: Shop_Home_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Các khối trang chủ web + Mini App. Thông tin liên hệ ở mục Liên hệ.`)
};

/**

* @param {Shop_Home_Page_SubtitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_page_subtitle = /** @type {((inputs?: Shop_Home_Page_SubtitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Page_SubtitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_page_subtitle(inputs)
});